export default "__VITE_ASSET__b184cf96__"